import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { ImageComponent } from '@/components/Image';
import { Pool } from '@/helpers/jackpot';

import { ScPool } from './styled';

export const PoolCard: FC<Pool> = ({
  title,
  prize,
  minBet,
  image,
  hitRange,
}) => {
  const { images } = useTheme();
  const { t } = useTranslation('jackpot');

  return (
    <ScPool>
      <div className="pool-icon">
        <ImageComponent src={image} alt="prize pool" width={88} height={88} />
      </div>
      <div className="title">{t(title)}</div>
      <div className="prize">{prize}</div>
      <div className="details">
        <div>
          <images.grayBetIcon.component />
          <div>{t('minBet', { sum: minBet })}</div>
        </div>
        <div>
          <images.moneyBag.component />
          <div>{t('hitRange', { range: hitRange })}</div>
        </div>
      </div>
    </ScPool>
  );
};
